import styled from 'styled-components';

export const StyledVideoControlsPanel = styled.div.attrs(props => ({
  className: props.className
}))`
  padding: 0 4px;
  width: 100%;
  color: #fff;
`;